export const healthLeeAchievementCategoryId = 'healthlee-achievements';
export const healthLeeAchievementTemplateCategoryId = 'system-healthlee-achievements';
